import ShiningStars from 'components/logistics/stats/shining_stars';
import React, { useEffect, useState } from 'react';
import { apiService } from 'utils/api';
import { SocketIOConnection } from 'utils/socket_client';

export type LogisticsRidersType = {
  name: string;
  profile_image: string;
  duration: number;
  no_of_orders: string;
  completed_order_percent: number;
  time_difference: number;
};
const LogisticsStatsPageFour = () => {
  const [data, setData] = useState<LogisticsRidersType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [onlineRiders, setOnlineRiders] = useState<string>('');
  const getOnlineRiders = async () => {
    try {
      const res = await apiService.post('logistics/team-rider-stat', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setOnlineRiders(res?.data?.data?.count);
    } catch (err: any) {
      console.log(err);
    }
  };
  const getRiders = async () => {
    try {
      const res = await apiService.post('logistics/team-weekly-performance', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      const riders = res.data.data;
      riders.sort((a: LogisticsRidersType, b: LogisticsRidersType) => {
        return parseInt(b.no_of_orders) - parseInt(a.no_of_orders);
      });
      setData(riders);
    } catch (err: any) {
      console.log(err);
    }
  };
  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      const res: any = await getRiders();
      setData(res);
    });

    const roomName = 'logistics-weekly-performance-stat';
    conn.addEventListener(roomName, 'update', (data: any) => {
      setData(data);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };
  const connectOnlineRidersSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      const res: any = await getRiders();
      setOnlineRiders(res);
    });

    const roomName = 'logistics-rider-stat';
    conn.addEventListener(roomName, 'update', (data: any) => {
      setOnlineRiders(data.count);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };
  useEffect(() => {
    setLoading(true);
    Promise.all([getRiders(), getOnlineRiders()]);
    setLoading(false);
    connectSocket();
    connectOnlineRidersSocket();
  }, []);
  return (
    <ShiningStars title={`${onlineRiders ?? 0} riders online 🚴🏾‍♂️`} data={data} loading={loading} />
  );
};

export default LogisticsStatsPageFour;
